import { Box, Typography } from "@material-ui/core";
import { FC, ReactElement } from "react";

const TitledText: FC<{ text: string | ReactElement; title: string; mx?: number }> = ({ title, text, mx = 0 }) => {
  return (
    <Box mb={1} mx={mx}>
      <Typography variant="body2">{title}</Typography>
      <Typography color="textSecondary" style={{ wordBreak: "break-all" }}>
        {text}
      </Typography>
    </Box>
  );
};

export default TitledText;
